import api from '@/api';

const resource = 'merenda/fornecedor';

export default {
  criarFornecedor( data ) {
    return api.post( `${resource}`, data );
  },

  editarFornecedor( data ) {
    return api.put( `${resource}/${data.identificadorfornecedor}`, data);
  },

  deletarFornecedor( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarFornecedores(data) {
    return api.get( `${resource}`, {
      params: data
    } );
  }
};
